import PropTypes from 'prop-types';
import type * as React from 'react';
import type { CSSProperties } from 'react';
import Spark from '..';

interface Props {
    x?: number;
    y?: number;
    zIndex?: number;
    children?: React.ReactNode;
    type?: string;
    story?: string;
    direction?: string;
}

export default function SparkPosition({ x = 0, y = 0, zIndex = 3, children, story, type, direction }: Props) {
    const style: CSSProperties = {
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
        width: '20px',
    };

    return (
        <span style={{ position: 'relative', zIndex }}>
            <span style={style}>
                {story && type ? <Spark story={story} type={type} direction={direction} /> : <span>{children}</span>}
            </span>
        </span>
    );
}

SparkPosition.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    direction: PropTypes.string,
    type: PropTypes.string,
    story: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
